export default __webpack_public_path__ + "static/media/resume-img.5b8bcdd3.png";